import {borderRadius, colors, shadows} from "./UIElements/Elements";
import TableButton from "./TableButton";

const TableListView = ({list = [], setActiveCategoryId}) => {
    const filteredTableList = list.filter(table => table.categoryId === setActiveCategoryId);
    return (
        <div className={`text-white relative pt-1 w-[100%] h-auto flex flex-wrap justify-start items-start 
        ${shadows.sm} ${borderRadius.small} ${colors.light}`}>
            {filteredTableList.map((table, index) => (
                <TableButton
                    key={table.name}
                    name={table.name}
                    status={table.status}
                    tableKey={table.name}
                    tableFoodStatus={table.foodStatus}
                />
            ))}
        </div>
    );
};

export default TableListView;
